import * as React from 'react';
import { Wrapper, Row, Title, TicketNo, TimeString, Status, Description, Container, TicketLink } from './ticketBlock.styles';
import * as dateformat from 'dateformat';
import { ticketColors } from '../../../utils/ticketColors';

interface Props {
  ticket: MaintenanceTicket;
}

export class TicketBlock extends React.Component<Props, {}> {
  public render() {
    const {mainColor, status, bgColor} = ticketColors(this.props.ticket);

    const timeString =  dateformat(new Date(this.props.ticket.timestamp), 'mm/dd/yyyy');

    return (
      <TicketLink to={`/ticket/${this.props.ticket.number}`}>
        <Container>
          <Wrapper color={bgColor}>
            <Row>
              <Title color={mainColor}>{this.props.ticket.title}</Title>
              <TicketNo color={mainColor}>Ticket #{this.props.ticket.number}</TicketNo>
            </Row>
            <Row>
              <TimeString>{timeString}</TimeString>
              <Status color={mainColor}>{status}</Status>
              <Description>{this.props.ticket.description}</Description>
            </Row>
          </Wrapper>
        </Container>
      </TicketLink>
    );
  }
}
